import { endRoute, parentRoute } from '$shared/utils/routes';

export const assessmentRoutes = {
  assessments: parentRoute('/assessment')({
    assessment: parentRoute<{ slug: string }>('/assessment/:slug')({
      step: endRoute<{ slug: string; step: string }>('/assessment/:slug/:step'),
    }),
  }),
};
